import i18next from 'i18next';

i18next.addResources('en', 'MashingInformationModal', {
  mashOperator: 'Mash Operator',
  firstTemperature: 'Temperature 1st Water',
  secondTemperature: 'Temperature 2nd Water',
  thirdTemperature: 'Temperature 3rd Water'
});
